import gql from "graphql-tag";

export const GetTutorials = gql`
  query GetTutorials {
    accounts(poll: true) {
      id
      isNmiAccount
      tutorials {
        id
        name
        version
      }
    }
  }
`;
